import { Button, ButtonType } from 'common/button';
import { useEffect, useState } from 'react';
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import styles from './prompt-categories-left-section.module.scss';

type LeftSectionProps = {
  questionSelected: number;
  unansweredQuestions: ClipType[];
  contributors: ContributorType[];
  owner: OwnerInfoType | undefined;
  handleContinue: () => void;
};

const PrompCategoriesLeftSection: React.FC<LeftSectionProps> = ({
  questionSelected,
  unansweredQuestions,
  contributors,
  owner,
  handleContinue,
}) => {
  const max = 6;
  const [state, setState] = useState({
    value: questionSelected,
    hideProgressCircule: false,
  });

  const getCreatorName = (): string => {
    const namesSet = new Set<string>();

    unansweredQuestions.forEach((clip) => {
      if (owner && clip.createdBy === owner.id) {
        namesSet.add(owner.name);
      } else {
        const contributor = contributors.find(
          (c) =>
            c.id === clip.createdBy || c.idContributorAux === clip.createdBy,
        );
        if (contributor) {
          namesSet.add(contributor.name);
        }
      }
    });

    const sortedNames = Array.from(namesSet).sort((a, b) => a.localeCompare(b));

    if (sortedNames.length <= 4) {
      return sortedNames.join(', ');
    }

    const firstThree = sortedNames.slice(0, 3).join(', ');
    const remainingCount = sortedNames.length - 3;
    return `${firstThree} and ${remainingCount} more editors...`;
  };

  useEffect(() => {
    const totalUnanswered = unansweredQuestions.length;
    const combined = totalUnanswered + questionSelected;

    setState({
      value: combined >= max ? max : combined,
      hideProgressCircule: totalUnanswered >= max,
    });
  }, [questionSelected, unansweredQuestions]);

  return (
    <div className={styles.containerLeft}>
      {!state.hideProgressCircule && (
        <div className={styles.progress}>
          <CircularProgressbarWithChildren
            value={state.value}
            maxValue={max}
            styles={buildStyles({
              pathColor: '#146975',
              trailColor: '#eaeaea',
              strokeLinecap: 'round',
            })}
          >
            <div className={styles.contentProgress}>
              <div className="text__body__regular__tiny__gray700">Topics</div>
              <strong className="text__heading4__gray800">
                {state.value}/{max}
              </strong>
            </div>
          </CircularProgressbarWithChildren>
        </div>
      )}
      <div className={styles.containerTitle}>
        <span className="text__heading3__gray800">Choose your topics</span>
        {!state.hideProgressCircule && unansweredQuestions.length === 0 && (
          <div className={styles.containerText}>
            <span className="text__body__regular__large__gray700">
              These will help us build your vault! We suggest adding at least 6
              topics to get started — you can always add more later.
            </span>
          </div>
        )}

        {(state.hideProgressCircule && unansweredQuestions.length > 0) ||
        (!state.hideProgressCircule && unansweredQuestions.length > 0) ? (
          <>
            <span className="text__body__regular__large__gray700">
              <strong>{getCreatorName()}</strong> have already added topics in
              your vault.
            </span>
            <span className="text__body__regular__large__gray700">
              You can add more or continue with the current selection. You can
              always edit topics later.
            </span>
          </>
        ) : null}
      </div>
      <Button
        buttonType={ButtonType.Button}
        className={styles.button}
        onClick={handleContinue}
      >
        Continue
      </Button>
    </div>
  );
};

export { PrompCategoriesLeftSection };
